import {getTaskApi, startOrEndTaskApi} from "../../../../services/User/calendar";
import useAuth from "../../../../hooks/useAuth";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Container from "@mui/material/Container";
import timestampToDate from "../../../../components/timestampToDate";

// const useStyles = makeStyles((theme) => ({
//     root: {
//         display: "flex",
//     },
//     toolbar: {
//         paddingRight: 24, // keep right padding when drawer closed
//     },
//     toolbarIcon: {
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "flex-end",
//         padding: "0 8px",
//         ...theme.mixins.toolbar,
//     },
//     appBar: {
//         zIndex: theme.zIndex.drawer + 1,
//         transition: theme.transitions.create(["width", "margin"], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//         }),
//         backgroundColor: "black"
//     },
//     appBarShift: {
//         transition: theme.transitions.create(["width", "margin"], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//     },
//     menuButton: {
//         marginRight: 36,
//     },
//     menuButtonHidden: {
//         display: "none",
//     },
//     title: {
//         flexGrow: 1,
//         color: "#ffffff"
//     },
//     drawerPaper: {
//         position: "relative",
//         whiteSpace: "nowrap",
//         transition: theme.transitions.create("width", {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//     },
//     appBarSpacer: theme.mixins.toolbar,
//     content: {
//         flexGrow: 1,
//         height: "100vh",
//         overflow: "auto",
//         background: "white",
//     },

// }));

export default function ShowTask(props) {
    const { logout } = useAuth()

    // const classes = useStyles()

    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const [titleModal, setTitleModal] = useState("Mostrar tarea")
    const [taskName, setTaskName] = useState(null)

    const [data, setData] = useState({})


    // Llamamos a la API para obtener los datos de la tarea, si no existe devolvemos error
    // Si no hay id, creamos la tarea
    useEffect(() => {
        getDataTask()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getDataTask = async () => {
        getTaskApi(props.idTask).then(response => {
            if (response.status) {
                setData(response.data.data)
                setLoading(false)
            } else {
                setMsgDanger(response.errors)
                setError(true)
                setLoading(false)
            }
        }).catch(error => {
            console.error(error)
        })
    }

    if (loading) return ""

    return (
        <>
            {/* <AppBar className={classes.appBar}> */}
            <AppBar>
                <Toolbar>
                    {/* <Typography variant="h6" className={classes.title}> */}
                    <Typography variant="h6" style={{flexGrow:"1"}}>
                        {error && (<p>ERROR</p>)}
                        {!error && (<>{titleModal} {taskName}</>)}
                    </Typography>

                    <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* <Container maxWidth="lg" className={classes.container}> */}
            <Container maxWidth="lg">

                <div className="mt-2">
                    <br />
                    <br />
                    <br />
                    <br />

                    {msgSuccess && (
                        <Grid item xs={12} md={12} lg={12}>
                            <Box className="alert-success">
                                Los datos de la tarea se han guardado correctamente
                            </Box>
                        </Grid>
                    )}

                    {msgDanger && (
                        <Grid item xs={12} md={12} lg={12}>
                            <Box className="alert-danger">
                                {msgDanger.map((item) => {
                                    return (<span>{item}<br /></span>)
                                })}
                            </Box>
                        </Grid>
                    )}

                    <div className="d-lg-block text-center mb-5">
                        <table style={{
                            margin: "auto",
                            minWidth: "250px",
                            borderSpacing: "4px"
                        }}>
                        <tbody>
                            <tr>
                                <td className="text-left pr-3"><strong>Servicio: </strong></td>
                                <td className="text-left">{data?.idService.name}</td>
                            </tr>

                            <tr>
                                <td className="text-left pr-3"><strong>Name: </strong></td>
                                <td className="text-left">{data?.idClient.name}</td>
                            </tr>
                            <tr>
                                <td className="text-left pr-3"><strong>Apellidos: </strong></td>
                                <td className="text-left">{data?.idClient.surnames}</td>
                            </tr>
                            <tr>
                                <td className="text-left pr-3"><strong>Dirección: </strong></td>
                                <td className="text-left">{data?.idClient.info}</td>
                            </tr>
                            <tr>
                                <td className="text-left pr-3"><strong>Población: </strong></td>
                                <td className="text-left">{data?.idMunicipality.name}</td>
                            </tr>
                            <tr>
                                <td className="text-left pr-3"><strong>Comarca: </strong></td>
                                <td className="text-left">{data?.idRegion.name}</td>
                            </tr>
                            <tr>
                                <td className="text-left pr-3"><br/><strong>Hora de inició:</strong></td>
                                <td className="text-left"><br/>{timestampToDate(data?.startHour, true)}</td>
                            </tr>
                            <tr>
                                <td className="text-left pr-3"><strong>Hora de finalización:</strong></td>
                                <td className="text-left">{timestampToDate(data?.endHour, true)}</td>
                            </tr>

                            {data.idClient.file && (
                                <tr>
                                    <td className="text-left pr-3" colspan="2">
                                        <br/>
                                        <a href={data.idClient.file} target="_blanck">Mostrar fichero</a>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        </table>
                    </div>



                </div>
            </Container>
        </>
    )

}
